module.exports = __webpack_public_path__ + "img/heater.5a4ee7fb.jpg";